import React, {useEffect, useEffectEvent} from 'react';
import {TransformComponent, useControls} from 'react-zoom-pan-pinch';
import type {SupplementModelV1} from '@albert-io/models';
import ImageRenderer from 'client/generic/ImageRenderer.react';

interface ImageWrapperProps extends PropsWithClassNameOptional {
  supplement: SupplementModelV1;
  shouldCenter?: boolean;
}

export const ImageWrapper = ({supplement, className, shouldCenter}: ImageWrapperProps) => {
  const {centerView} = useControls();
  // useControls returns a new centerView closure every render; depending on it
  // re-centered on every parent re-render and cut running zoom animations short.
  const centerViewEvent = useEffectEvent(() => centerView());
  useEffect(() => {
    if (shouldCenter) {
      centerViewEvent();
    }
  }, [shouldCenter]);
  return (
    <TransformComponent
      wrapperStyle={{
        width: '100%',
        height: '100%'
      }}
      contentStyle={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <ImageRenderer className={className} supplement={supplement} />
    </TransformComponent>
  );
};
